module.exports = __webpack_public_path__ + "static/media/S (63).1b0208bd.jpg";